/*==============================================================================
  ___  _   _    _
 /   || | | |  | |
 \__  | | | |  | |  __
 /    |/  |/_) |/  /  \_/\/
 \___/|__/| \_/|__/\__/  /\_/
               |\
               |/
  Concrete v0.1
  https://elkfox.com
  https://experts.shopify.com/elkfox
  Copyright 2017 Shopify Inc. & Elkfox Co Pty Ltd
==============================================================================*/

// Default selectors
var parentContainer = (typeof parentContainer === 'undefined') ? '#MainContent' : parentContainer, // All of the content selector used to detect scroll bottom distance
  endlessScrollContainer = (typeof endlessScrollContainer === 'undefined') ? '#EndlessScroll' : endlessScrollContainer, // Selector for endless scroll pages
  endlessClickContainer = (typeof endlessClickContainer === 'undefined') ? '#EndlessClick' : endlessClickContainer, // Class of pagination container
  ajaxinateContainer = (typeof ajaxinateContainer === 'undefined') ? '#Ajaxinate' : ajaxinateContainer, // ID Selector for ajax pagination pages
  endlessLink = (typeof endlessLink === 'undefined') ? '.LoadMore' : endlessLink, // Class Selector for endless click + scroll
  ajaxinateLink = (typeof ajaxinateLink === 'undefined') ? '.PaginationLink' : ajaxinateLink, // Class Selector for ajax pagination links
  ajaxinateClass = (typeof ajaxinateClass == 'undefined') ? '.ajaxcontainer' : ajaxinateClass, // Class of pagination container
  fade = (typeof fade === 'undefined') ? '100' : fade, // fade speed
  linkElem,
  contentContainer,
  pageNumber,
  pageType,
  action,
  moreURL;

var Ajaxinate = {
  init: function () {
    if ($(ajaxinateContainer).length) {
      linkElem = ajaxinateLink;
      Ajaxinate.ajaxinationClick();
    }
    if ($(endlessClickContainer).length) {
      linkElem = endlessLink + ' a';
      Ajaxinate.endlessClick();
    }
    if ($(endlessScrollContainer).length) {
      linkElem = endlessLink + ' a';
      Ajaxinate.endlessScroll();
    }
  },
  load: function () {
    if (moreURL.length) {
      $.ajax({
        type: 'GET',
        dataType: 'html',
        url: moreURL,
        success: function (data) {
          var pageValueRegex = moreURL.match(/page=([^&]*)/);
          var pageValue = pageValueRegex ? pageValueRegex[1] : 1;
          if (pageType == 'ajax') {
            $(ajaxinateClass).not('[data-page="' + pageNumber + '"]').hide();
            history.pushState({}, pageNumber, moreURL);
          } else {
            $(linkElem).parent().parent().hide();
          }
          var filteredData = $(data).find(contentContainer).html();
          $(filteredData).appendTo($(contentContainer)).hide().fadeIn(fade);

          if ($('.collection-description').length > 0 && pageValue > 1) {
            $('.collection-description').remove();
          }

          if (pageType == 'endlessScroll') {
            Ajaxinate.endlessScroll();
          } else if (pageType == 'ajax') {
            Ajaxinate.ajaxinationClick();
          } else if (pageType == 'endlessClick') {
            Ajaxinate.endlessClick();
          }
          if (typeof concrete.badges.sticker === "function") {
            concrete.badges.sticker();
          }
        }
      });
    }
  },
  ajaxinationClick: function () {
    $(linkElem).on('click', function (e) {
      e.preventDefault();
      action = 'click';
      contentContainer = ajaxinateContainer;
      moreURL = $(this).attr('href');
      pageNumber = $(this).attr('data-number');
      pageType = 'ajax';
      $('html, body').animate({
        scrollTop: $(parentContainer).offset().top
      }, fade);
      if ($(ajaxinateClass + '[data-page="' + pageNumber + '"]').length) {
        $(ajaxinateClass).not('[data-page="' + pageNumber + '"]').fadeOut();
        $(ajaxinateClass + '[data-page="' + pageNumber + '"]').fadeIn(fade);
        history.pushState({}, pageNumber, moreURL);
      } else {
        $(linkElem).off(action);
        Ajaxinate.load();
      }
    });
  },
  endlessClick: function () {
    $(linkElem).on('click', function (e) {
      e.preventDefault();
      var textChange = "Loading more...";
      action = 'click';
      contentContainer = endlessClickContainer;
      moreURL = $(this).attr('href');
      pageType = 'endlessClick';
      $(linkElem).text(textChange);
      $(linkElem).off(action);
      Ajaxinate.load();
    });
  },
  endlessScroll: function () {
    action = 'scroll load resize';
    $(window).on(action, function () {
      var textChange = "Loading more...";
      contentContainer = endlessScrollContainer;
      moreURL = $(contentContainer + ':last-of-type ' + linkElem).attr('href');
      pageType = 'endlessScroll';
      $(linkElem).text(textChange);
      if ($(contentContainer + ':last-of-type ' + linkElem).length) {
        var bottom = $(parentContainer).outerHeight(),
          docTop = ($(document).scrollTop() + $(window).height());
        if (docTop > bottom) {
          $(window).off(action);
          Ajaxinate.load();
        }
      }
    });
  }
}

// Pagination initiation
Ajaxinate.init();
